var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.1875C0 0.531662 0.531662 0 1.1875 0H16.8125C17.4683 0 18 0.531662 18 1.1875V8.8125C18 9.46834 17.4683 10 16.8125 10H1.1875C0.531662 10 0 9.46834 0 8.8125V1.1875Z",
    fill: "#3290EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0485 7.69113V3H12.1035L14.4104 6.05943L14.0235 6.87528V3H15.191V7.69113H14.2627L11.9417 4.70906L12.209 4.13234V7.69113H11.0485Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1601 7.69113V3H9.44013V7.69113H8.1601Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7372 7.69113L2 3H3.47697L4.74294 6.93155H4.33502L5.59395 3H6.95136L5.10163 7.69113H3.7372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVin);
export default __webpack_public_path__ + "static/media/vin.b2b4637a477cb7cc750ca74aa0b7a3a1.svg";
export { ForwardRef as ReactComponent };